export const initialState = {
    voetmax: false,
    backend: { key: "", type: "podoit", value: "", idp: "" },
    dataProvider: 'vcw',
    errorDialog: false,
    allValid: false,
    previousOrders: [],
    breakTheGlass: false
}
